var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeartFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 13 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  stroke: "#333",
  strokeWidth: 1.25,
  d: "m6.07 2.883.454.453.442-.465.469-.493c1.072-1.09 2.714-1.232 3.796-.308 1.29 1.106 1.352 3.077.206 4.265L6.61 11.31l-.005.005-.006.006a.13.13 0 0 1-.1.042.13.13 0 0 1-.1-.042l-.006-.005-.005-.006-4.825-4.975C.416 5.147.48 3.175 1.768 2.07c1.086-.927 2.752-.779 3.795.307l.009.008z"
})));
export default SvgHeartFilled;